import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { FormattedMessage, defineMessages } from 'react-intl'

// Selectors
import { selectLatestQuartileMarketValue } from '../../../../../store/selectors/marketRecord'

// Components
import { ExpandablePanel, Text, Button } from '../../../..'

// Constants
import { MARKET_VALUE_BREAK_POINTS } from '../../../../../constants/marketRecords'
import { MARKET_TEMP_KEYS } from '../../../../../constants/shouldYouSell'
import { EXPANDED_MARKET_TEMP_SELL_EVENT } from '../../../../../constants/client/clientEvents'
import { ExpandedShouldYouSellMarketTemp } from '../../../../../constants/trackingEvents'
import MarketTempSellLabel from './MarketTempSellLabel'

// Styles
import baseStyles from '../ShouldYouSell.module.scss'

const MarketTempSell = ({ doMarketNav, className }) => {
  const latestMarketValue = useSelector(selectLatestQuartileMarketValue)

  let key

  if (latestMarketValue > MARKET_VALUE_BREAK_POINTS.HIGH) {
    key = MARKET_TEMP_KEYS.HOTISH
  } else if (latestMarketValue > MARKET_VALUE_BREAK_POINTS.MODERATE) {
    key = MARKET_TEMP_KEYS.BALANCED
  } else {
    key = MARKET_TEMP_KEYS.COLDISH
  }

  const handleClick = doMarketNav

  return (
    <ExpandablePanel
      className={classnames(baseStyles.panel, className)}
      eventName={EXPANDED_MARKET_TEMP_SELL_EVENT}
      googleAnalyticsEventName={ExpandedShouldYouSellMarketTemp}
      data-qa='market-temp-sell'
    >
      <ExpandablePanel.Label>
        <MarketTempSellLabel />
      </ExpandablePanel.Label>
      <ExpandablePanel.Body>
        <Text variant='neutralCool' variantCount='900'>
          <FormattedMessage {...description[key]} />
        </Text>
        <Button
          onClick={handleClick}
          className={classnames(baseStyles.bottomButton)}
        >
          <FormattedMessage
            id='ShouldYouSell.MarketTempSellLabel.button'
            defaultMessage='More market insights'
          />
        </Button>
      </ExpandablePanel.Body>
    </ExpandablePanel>
  )
}

const description = defineMessages({
  [MARKET_TEMP_KEYS.HOTISH]: {
    id: 'ShouldYouSell.MarketTempSellLabel.desc.hotish',
    defaultMessage:
      'An in demand market means you may be able to sell your home faster and for more money',
  },
  [MARKET_TEMP_KEYS.BALANCED]: {
    id: 'ShouldYouSell.MarketTempSellLabel.desc.balanced',
    defaultMessage:
      'A balanced market has decent inventory and a healthy amount of buyers - you could likely sell your home on an average timeline for a moderate amount',
  },
  [MARKET_TEMP_KEYS.COLDISH]: {
    id: 'ShouldYouSell.MarketTempSellLabel.desc.coldish',
    defaultMessage:
      'A cooler market means it might take more time to sell your home and possibly for less money',
  },
})

MarketTempSell.propTypes = {
  doMarketNav: PropTypes.func,
  className: PropTypes.string,
}

export default MarketTempSell
